import { ColorCodes } from "../../../../types/common";

const colorCodes: ColorCodes = {
  white: "#4d4d4d",
  red: "#f95460",
  orange: "#ffb554",
  redShadow: "#f95460",
  green: "#65F4CD",
  greenShadow: "#65F4CD",
};

export default colorCodes;

